/* eslint-disable */
import * as Types from './types';

import { ModuleBannerFragmentDoc } from './ModuleBanner';
import { ImageFragmentDoc } from './Image';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type GetFormPageQueryVariables = Types.Exact<{
  handle: Types.Scalars['String'];
  locale?: Types.InputMaybe<Types.Scalars['String']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']>;
  tagFilter?: Types.InputMaybe<Types.FormPageFilter>;
}>;


export type GetFormPageQuery = { __typename?: 'Query', formPage?: { __typename?: 'FormPageCollection', data: Array<{ __typename?: 'FormPage', seoTitle?: string | null, seoDescription?: string | null, title?: string | null, termsAndConditionsUrl?: string | null, toAddress?: string | null, banner?: { __typename?: 'ModuleBanner', copy?: string | null, copyPosition?: string | null, backgroundColor?: string | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null, copy?: { __typename?: 'FormPageCopy', json: object } | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null };

export type GetSignUpPopupFormPageQueryVariables = Types.Exact<{
  locale?: Types.InputMaybe<Types.Scalars['String']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']>;
  tagFilter?: Types.InputMaybe<Types.FormPageFilter>;
}>;


export type GetSignUpPopupFormPageQuery = { __typename?: 'Query', formPage?: { __typename?: 'FormPageCollection', data: Array<{ __typename?: 'FormPage', seoTitle?: string | null, seoDescription?: string | null, title?: string | null, termsAndConditionsUrl?: string | null, toAddress?: string | null, banner?: { __typename?: 'ModuleBanner', copy?: string | null, copyPosition?: string | null, backgroundColor?: string | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null, copy?: { __typename?: 'FormPageCopy', json: object } | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null };

export type GetSignUpConfirmedPopupFormPageQueryVariables = Types.Exact<{
  locale?: Types.InputMaybe<Types.Scalars['String']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']>;
  tagFilter?: Types.InputMaybe<Types.FormPageFilter>;
}>;


export type GetSignUpConfirmedPopupFormPageQuery = { __typename?: 'Query', formPage?: { __typename?: 'FormPageCollection', data: Array<{ __typename?: 'FormPage', seoTitle?: string | null, seoDescription?: string | null, title?: string | null, termsAndConditionsUrl?: string | null, toAddress?: string | null, banner?: { __typename?: 'ModuleBanner', copy?: string | null, copyPosition?: string | null, backgroundColor?: string | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null, copy?: { __typename?: 'FormPageCopy', json: object } | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null };

export type GetSupportFormPageQueryVariables = Types.Exact<{
  locale?: Types.InputMaybe<Types.Scalars['String']>;
  preview?: Types.InputMaybe<Types.Scalars['Boolean']>;
  handle: Types.Scalars['String'];
  tagFilter?: Types.InputMaybe<Types.FormPageFilter>;
}>;


export type GetSupportFormPageQuery = { __typename?: 'Query', formPage?: { __typename?: 'FormPageCollection', data: Array<{ __typename?: 'FormPage', toAddress?: string | null } | null> } | null };

export declare const getFormPage: import("graphql").DocumentNode;
export declare const getSignUpPopupFormPage: import("graphql").DocumentNode;
export declare const getSignUpConfirmedPopupFormPage: import("graphql").DocumentNode;
export declare const getSupportFormPage: import("graphql").DocumentNode;

export const GetFormPageDocument = /*#__PURE__*/ `
    query getFormPage($handle: String!, $locale: String = "en-US", $preview: Boolean = false, $tagFilter: FormPageFilter) {
  formPage: formPageCollection(
    limit: 1
    locale: $locale
    preview: $preview
    where: {AND: [{handle: $handle}, $tagFilter, {sys: {id_exists: true}}]}
  ) {
    data: items {
      banner {
        ...ModuleBannerFragment
      }
      seoTitle
      seoDescription
      title
      termsAndConditionsUrl
      toAddress
      copy {
        json
      }
      image {
        ...ImageFragment
      }
    }
  }
}
    ${ModuleBannerFragmentDoc}
${ImageFragmentDoc}`;
export const useGetFormPageQuery = <
      TData = GetFormPageQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetFormPageQueryVariables,
      options?: UseQueryOptions<GetFormPageQuery, TError, TData>
    ) =>
    useQuery<GetFormPageQuery, TError, TData>(
      ['getFormPage', variables],
      fetcher<GetFormPageQuery, GetFormPageQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetFormPageDocument, variables, options),
      options
    );

useGetFormPageQuery.getKey = (variables: GetFormPageQueryVariables) => ['getFormPage', variables];
;

useGetFormPageQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: GetFormPageQueryVariables, options?: RequestInit['headers']) => fetcher<GetFormPageQuery, GetFormPageQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetFormPageDocument, variables, options);
export const GetSignUpPopupFormPageDocument = /*#__PURE__*/ `
    query getSignUpPopupFormPage($locale: String = "en-US", $preview: Boolean = false, $tagFilter: FormPageFilter) {
  formPage: formPageCollection(
    limit: 1
    locale: $locale
    preview: $preview
    where: {AND: [{handle: "sign-up-pop-up"}, $tagFilter, {sys: {id_exists: true}}]}
  ) {
    data: items {
      banner {
        ...ModuleBannerFragment
      }
      seoTitle
      seoDescription
      title
      termsAndConditionsUrl
      toAddress
      copy {
        json
      }
      image {
        ...ImageFragment
      }
    }
  }
}
    ${ModuleBannerFragmentDoc}
${ImageFragmentDoc}`;
export const useGetSignUpPopupFormPageQuery = <
      TData = GetSignUpPopupFormPageQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: GetSignUpPopupFormPageQueryVariables,
      options?: UseQueryOptions<GetSignUpPopupFormPageQuery, TError, TData>
    ) =>
    useQuery<GetSignUpPopupFormPageQuery, TError, TData>(
      variables === undefined ? ['getSignUpPopupFormPage'] : ['getSignUpPopupFormPage', variables],
      fetcher<GetSignUpPopupFormPageQuery, GetSignUpPopupFormPageQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetSignUpPopupFormPageDocument, variables, options),
      options
    );

useGetSignUpPopupFormPageQuery.getKey = (variables?: GetSignUpPopupFormPageQueryVariables) => variables === undefined ? ['getSignUpPopupFormPage'] : ['getSignUpPopupFormPage', variables];
;

useGetSignUpPopupFormPageQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables?: GetSignUpPopupFormPageQueryVariables, options?: RequestInit['headers']) => fetcher<GetSignUpPopupFormPageQuery, GetSignUpPopupFormPageQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetSignUpPopupFormPageDocument, variables, options);
export const GetSignUpConfirmedPopupFormPageDocument = /*#__PURE__*/ `
    query getSignUpConfirmedPopupFormPage($locale: String = "en-US", $preview: Boolean = false, $tagFilter: FormPageFilter) {
  formPage: formPageCollection(
    limit: 1
    locale: $locale
    preview: $preview
    where: {AND: [{handle: "sign-up-confirmed-pop-up"}, $tagFilter, {sys: {id_exists: true}}]}
  ) {
    data: items {
      banner {
        ...ModuleBannerFragment
      }
      seoTitle
      seoDescription
      title
      termsAndConditionsUrl
      toAddress
      copy {
        json
      }
      image {
        ...ImageFragment
      }
    }
  }
}
    ${ModuleBannerFragmentDoc}
${ImageFragmentDoc}`;
export const useGetSignUpConfirmedPopupFormPageQuery = <
      TData = GetSignUpConfirmedPopupFormPageQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables?: GetSignUpConfirmedPopupFormPageQueryVariables,
      options?: UseQueryOptions<GetSignUpConfirmedPopupFormPageQuery, TError, TData>
    ) =>
    useQuery<GetSignUpConfirmedPopupFormPageQuery, TError, TData>(
      variables === undefined ? ['getSignUpConfirmedPopupFormPage'] : ['getSignUpConfirmedPopupFormPage', variables],
      fetcher<GetSignUpConfirmedPopupFormPageQuery, GetSignUpConfirmedPopupFormPageQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetSignUpConfirmedPopupFormPageDocument, variables, options),
      options
    );

useGetSignUpConfirmedPopupFormPageQuery.getKey = (variables?: GetSignUpConfirmedPopupFormPageQueryVariables) => variables === undefined ? ['getSignUpConfirmedPopupFormPage'] : ['getSignUpConfirmedPopupFormPage', variables];
;

useGetSignUpConfirmedPopupFormPageQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables?: GetSignUpConfirmedPopupFormPageQueryVariables, options?: RequestInit['headers']) => fetcher<GetSignUpConfirmedPopupFormPageQuery, GetSignUpConfirmedPopupFormPageQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetSignUpConfirmedPopupFormPageDocument, variables, options);
export const GetSupportFormPageDocument = /*#__PURE__*/ `
    query getSupportFormPage($locale: String = "en-US", $preview: Boolean = false, $handle: String!, $tagFilter: FormPageFilter) {
  formPage: formPageCollection(
    limit: 1
    locale: $locale
    preview: $preview
    where: {AND: [{handle: $handle}, $tagFilter, {sys: {id_exists: true}}]}
  ) {
    data: items {
      toAddress
    }
  }
}
    `;
export const useGetSupportFormPageQuery = <
      TData = GetSupportFormPageQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetSupportFormPageQueryVariables,
      options?: UseQueryOptions<GetSupportFormPageQuery, TError, TData>
    ) =>
    useQuery<GetSupportFormPageQuery, TError, TData>(
      ['getSupportFormPage', variables],
      fetcher<GetSupportFormPageQuery, GetSupportFormPageQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetSupportFormPageDocument, variables, options),
      options
    );

useGetSupportFormPageQuery.getKey = (variables: GetSupportFormPageQueryVariables) => ['getSupportFormPage', variables];
;

useGetSupportFormPageQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: GetSupportFormPageQueryVariables, options?: RequestInit['headers']) => fetcher<GetSupportFormPageQuery, GetSupportFormPageQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetSupportFormPageDocument, variables, options);